import React from "react";
import { FOOTER } from "../../../layout/kor/footer";
import { SUBHEADER } from "../../../layout/kor/subheader";
import { Philosophy } from "../../../parts/kor/intro/philosophy";
class PHILOSOPHY extends React.Component {
  render() {
    return (
      <main id="content">
        <SUBHEADER />
        <div id="intro">
          <Philosophy />
        </div>
        <FOOTER />
      </main>
    );
  }
}
export default PHILOSOPHY;
